import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import MainPage from "../page/mainPage/mainPage";
import Aitb from "../page/aitb/Aitb";
import Brief from "../page/brief/Brief";
import SearchResult from "../page/search/SearchResult";
import ScrapList from "../page/scrap/ScrapList";
import ReportList from "../page/report/ReportList";
import Report from "../page/report/Report";
import SignUp from "../page/signUp/SignUp";
import SignIn from "../page/signIn/SignIn";

import { userState } from "../interface/MainInterface";
import { useEffect, useRef } from "react";
import * as AuthMain from "../auth/AuthMain";

import Toast from "../utils/Toast";
import Article from "../page/brief/Article";
import Brief2 from "../page/brief/Brief2";
import StatisticPage from "../page/statistic/StatisticPage";
import UserMng from "../page/signUp/UserMng";
import { useWindowSize } from "../utils/useWindowSize";
import Setting from "../page/admin/Setting";
import HartLogIn from "../page/signIn/HartLogin";
import KeywordGrouping from "../page/scrap/KeywordGrouping";
import Setting2 from "../page/admin/Setting2";
import RunwayList from "../page/runway/RunwayList";
import Runway from "../page/runway/Runway";
import SsoLogin from "../page/signIn/SsoLogin";

interface propsType {
  userState: userState;
  setSelectedMenu: any;
  briefList: any;
  setBriefList: any;
  searchText: string;
  setSearchText: any;
  selectedPeriod: string;
  setSelectedPeriod: any;
  lastEvalKey: any;
  setLastEvalKey: any;
  nowPageSize: number;
  setNowPageSize: any;
  lastScrollPos: number;
  setLastScrollPos: any;
  needRefresh: boolean;
  setNeedRefresh: any;
}

const MainConteiner = (props: propsType) => {
  const location = useLocation();
  const toastRef: any = useRef();
  const windowSize = useWindowSize();

  const tPrefix = "3479812398712";
  const tSuffix = "4298381203831";
  const stateInfo: URLSearchParams = new URLSearchParams(
    window.location.search
  );

  useEffect(() => {
    const sessionCheck = async () => {
      try {
        if (!(await AuthMain.checkAuthenticated()) && (!AuthMain.getSession())) {
          if (!stateInfo.get("tKey")) {
            moveHome();
          } else {
            const keyInfo: string = stateInfo.get("tKey") as string;
            const hasValidPrefixAndSuffix = keyInfo.startsWith(tPrefix) && keyInfo.endsWith(tSuffix);
            if (!hasValidPrefixAndSuffix) {
              moveHome();
            }
          }
        } else {
          props.setSelectedMenu(`/${location.pathname.split("/")[1]}`);
        }
      } catch (error) {
        moveHome();
      }
    };

    const moveHome = () => {
      toastRef.current?.toast("세션이 종료되었습니다.\n로그인 화면으로 이동합니다.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      setTimeout(() => {
        window.location.href = "/signin";
      }, 3000);
    };

    const pathName = `/${location.pathname.split("/")[1]}`;
    if (pathName === "/main" || pathName === "/signin" || pathName === "/userMng" || pathName === "/report" || pathName === "/hartlogin") {
      props.setSelectedMenu(pathName);
    } else {
      sessionCheck();
    }
  }, [location, props]);
  return (
    <>
      <Routes>
        {props.userState.isSuperAdmin && windowSize.width > 1439 && (
          <>
            <Route path="/userMng" element={<UserMng userState={props.userState} />} />
            <Route path="/statistic" element={<StatisticPage userState={props.userState} />} />
            <Route path="/setting" element={<Setting2 userState={props.userState} />} />
          </>
        )}
        <Route
          path="/"
          element={
            <Aitb
              userState={props.userState}
              briefList={props.briefList}
              setBriefList={props.setBriefList}
              selectedPeriod={props.selectedPeriod}
              setSelectedPeriod={props.setSelectedPeriod}
              lastEvalKey={props.lastEvalKey}
              setLastEvalKey={props.setLastEvalKey}
              nowPageSize={props.nowPageSize}
              setNowPageSize={props.setNowPageSize}
              lastScrollPos={props.lastScrollPos}
              setLastScrollPos={props.setLastScrollPos}
              needRefresh={props.needRefresh}
              setNeedRefresh={props.setNeedRefresh}
            />
          }
        />
        <Route path="/main" element={<MainPage userState={props.userState} />} />
        <Route
          path="/search"
          element={
            <SearchResult
              userState={props.userState}
              briefList={props.briefList}
              setBriefList={props.setBriefList}
              searchText={props.searchText}
              setSearchText={props.setSearchText}
              selectedPeriod={props.selectedPeriod}
              setSelectedPeriod={props.setSelectedPeriod}
              lastEvalKey={props.lastEvalKey}
              setLastEvalKey={props.setLastEvalKey}
              nowPageSize={props.nowPageSize}
              setNowPageSize={props.setNowPageSize}
              lastScrollPos={props.lastScrollPos}
              setLastScrollPos={props.setLastScrollPos}
              needRefresh={props.needRefresh}
              setNeedRefresh={props.setNeedRefresh}
            />
          }
        />
        {props.userState.isAdmin && (
          <>
            <Route path="/reportList" element={<ReportList userState={props.userState} />} />
            <Route path="/group/:sk" element={<KeywordGrouping userState={props.userState} />} />
          </>
        )}
        
        <Route path="/brief/:pk/:sk" element={<Brief2 userState={props.userState} />} />
        <Route path="/article/:pk/:sk" element={<Article userState={props.userState} />} />
        <Route path="/runway" element={<RunwayList lastScrollPos={props.lastScrollPos} setLastScrollPos={props.setLastScrollPos} />} />
        <Route path="/runway/:season/:designer" element={<Runway />} />
        <Route path="/scrapList" element={<ScrapList userState={props.userState} />} />
        <Route path="/report/:sk" element={<Report userState={props.userState} />} />
        <Route path="/signin" element={<SignIn userState={props.userState} />} />
        <Route path="/hartlogin" element={<HartLogIn userState={props.userState} />} />
        <Route path="/ssologin" element={<SsoLogin userState={props.userState} />}
        />
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
      <Toast ref={toastRef} />
    </>
  );
};

export default MainConteiner;
